import { render, staticRenderFns } from "./china_new.vue?vue&type=template&id=cc58b1a4&scoped=true&"
import script from "./china_new.vue?vue&type=script&lang=js&"
export * from "./china_new.vue?vue&type=script&lang=js&"
import style0 from "./china_new.vue?vue&type=style&index=0&id=cc58b1a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc58b1a4",
  null
  
)

export default component.exports